import * as React from "react";
import { Alert } from "../../Components/Alert";
import { AlertType } from "../../Entities/Constants/AlertConstants";

interface IProcessErrorMsg {
    msg: string[];
}

export const PROCESS_ERROR_MSG_DIV_ID = "process-error-msg-div";

export const ProcessErrorMsg = (props: IProcessErrorMsg) => {
    if (!props.msg || props.msg.length == 0) {return null;}

    return (
        <div id={PROCESS_ERROR_MSG_DIV_ID}>
            {props.msg.map((ele, i) => (
                <Alert alertType={AlertType.Error} message={ele} key={`error-${i}`} />
            ))}
        </div>
    );
};
